export default function addAPlanReducer(state, action) {
  return {
    ...state,
    policyDetails: Object.assign({}, state.policyDetails, {
      Policies: [
        ...state.policyDetails.Policies.slice(0, action.payload.index),
        action.payload.policy,
        ...state.policyDetails.Policies.slice(action.payload.index)
      ]
    })
  };
}
